$(".workorderInputs").on("change", function (e) {
    $("#workordersform").submit();
})



// WEBPACK FOOTER //
// ./resources/js/components/workorders.js